import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=3ddda206&scoped=true&"
import script from "./Location.vue?vue&type=script&lang=js&"
export * from "./Location.vue?vue&type=script&lang=js&"
import style0 from "./Location.vue?vue&type=style&index=0&id=3ddda206&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddda206",
  null
  
)

export default component.exports